<template>
  <div class="new-password">
    <div class="center">
      <h1>{{ $t("newPasswordPage.title") }}</h1>
      <form @submit.prevent="submit">
        <input type="password" v-model="newPassword" class="password-input" />
        <button type="submit" class="submit-button">{{ $t("newPasswordPage.submitButton") }}</button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Auth } from "aws-amplify";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  name: "newPassword",
  props: {
    username: String,
  },
  data() {
    return {
      newPassword: "",
    };
  },
  methods: {
    async submit() {
      const { newPassword } = this;

      const user = await Auth.currentUserPoolUser();
      await Auth.completeNewPassword(user, newPassword, {});
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";
.new-password {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center {
  margin: 30px 10%;
  padding: 30px 50px;
  background-color: var(--color-surface-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-normal);
  text-align: center;
  border-radius: var(--radius-md);

  @include mq(sp) {
    margin: 50px 15px;
    padding: 20px;
  }
}

h1 {
  font-size: var(--font-size-xl);
  color: var(--color-text-normal);
  margin-bottom: 20px;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.password-input {
  padding: 12px 16px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
  font-size: var(--font-size-md);
  width: 100%;
  max-width: 300px;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
  }
}

.submit-button {
  padding: 12px 50px;
  border-radius: var(--radius-rounded);
  background-color: var(--color-primary);
  font-size: var(--font-size-md);
  color: var(--color-text-on-fixed-bg);
  cursor: pointer;
  border: none;
  position: relative;
  @include hover-overlay;
}
</style>
